import { default as restDel } from './restDel';
import { default as restGet } from './restGet';
import { default as restPatch } from './restPatch';
import { default as restPost } from './restPost';

const api = { del: restDel, get: restGet, patch: restPatch, post: restPost };

export { api };
